import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Layout from '../components/Layout';
import { guideParts } from '../data/awsClfGuideData';
import './AWSCloudFundamentalsCourse.css';

type Tab = 'overview' | string;

const AWSCLFC02GuidePage: React.FC = () => {
  const [tab, setTab] = useState<Tab>('overview');

  const go = (t: Tab) => {
    setTab(t);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const part = guideParts.find((p) => p.id === tab);
  const partIndex = guideParts.findIndex((p) => p.id === tab);

  return (
    <Layout>
      <div className="page-hero">
        <div style={{ maxWidth: '1200px', margin: '0 auto', padding: '0 6%' }}>
          <div style={{ fontSize: '0.9rem', color: 'var(--gray-600)', marginBottom: '12px' }}>
            <Link to="/programs" style={{ color: 'var(--blue)' }}>Programs</Link> /{' '}
            <Link to="/aws-ccp" style={{ color: 'var(--blue)' }}>AWS Cloud Practitioner</Link> / Complete Study Guide
          </div>
          <h1>AWS Cloud Practitioner (CLF-C02): Complete Study Guide</h1>
          <p>Everything for your 4-week path in one place: detailed explanations with diagrams for each week. Read a topic each week, then test yourself with the practice questions.</p>
          <div style={{ marginTop: '16px', display: 'flex', gap: '8px', flexWrap: 'wrap', justifyContent: 'center' }}>
            <span className="section-tag">Beginner · 4 weeks</span>
            <span className="section-tag">4 topics</span>
            <span className="section-tag orange">Diagram-led</span>
          </div>
        </div>
      </div>

      <div className="cf-nav">
        <div className="cf-nav-inner">
          <button className={`cf-tab${tab === 'overview' ? ' on' : ''}`} onClick={() => go('overview')}>🗺️ Overview</button>
          {guideParts.map((p) => (
            <button key={p.id} className={`cf-tab${tab === p.id ? ' on' : ''}`} onClick={() => go(p.id)}>{p.week}</button>
          ))}
          <Link to="/aws-clf-c02-practice" className="cf-tab" style={{ marginLeft: 'auto', textDecoration: 'none' }}>📝 Practice →</Link>
        </div>
      </div>

      <div className="cf section" style={{ paddingTop: '20px' }}>
        <div className="cf-body">
          <svg width="0" height="0" style={{ position: 'absolute' }}>
            <defs>
              <marker id="h" markerWidth="8" markerHeight="8" refX="6" refY="4" orient="auto">
                <path d="M0,0 L8,4 L0,8z" fill="#5f6881" />
              </marker>
            </defs>
          </svg>

          {tab === 'overview' && (
            <>
              <div className="sh">
                <i>🗺️</i>
                <div>
                  <h2>How to use this guide</h2>
                  <small>One topic per week, then practise</small>
                </div>
              </div>
              <div className="cf-hub">
                {guideParts.map((p) => (
                  <button key={p.id} onClick={() => go(p.id)}>
                    <span className="cf-pill2">{p.week}</span>
                    <h3>{p.title}</h3>
                    <p>{p.desc}</p>
                  </button>
                ))}
                <Link to="/aws-clf-c02-practice" style={{ textDecoration: 'none' }}>
                  <button style={{ width: '100%', height: '100%' }}>
                    <span className="cf-pill2">All weeks</span>
                    <h3>Practice Questions by Topic</h3>
                    <p>Interactive questions grouped by topic with instant feedback and a running score.</p>
                  </button>
                </Link>
              </div>
            </>
          )}

          {part && (
            <>
              <div className="cf-banner">
                <span className="cf-pill">{part.week}</span>
                <h2>{part.title}</h2>
                <p>{part.desc}</p>
              </div>
              <div className="cf-chips">
                {part.sections.map((s) => (
                  <a
                    key={s.id}
                    href={`#${s.id}`}
                    onClick={(e) => {
                      e.preventDefault();
                      document.getElementById(s.id)?.scrollIntoView({ behavior: 'smooth', block: 'start' });
                    }}
                  >
                    {s.icon} {s.title.replace(/&amp;/g, '&')}
                  </a>
                ))}
              </div>
              {part.sections.map((s) => (
                <section className="les" id={s.id} key={s.id} style={{ scrollMarginTop: '130px' }}>
                  <div className="sh">
                    <i>{s.icon}</i>
                    <div>
                      <h2 dangerouslySetInnerHTML={{ __html: s.title }} />
                      <small>{s.subtitle}</small>
                    </div>
                  </div>
                  <div dangerouslySetInnerHTML={{ __html: s.html }} />
                </section>
              ))}
              <div className="cf-pager">
                <button className="btn btn-outline-blue" onClick={() => go(partIndex > 0 ? guideParts[partIndex - 1].id : 'overview')}>← Previous</button>
                {partIndex < guideParts.length - 1 ? (
                  <button className="btn btn-blue" onClick={() => go(guideParts[partIndex + 1].id)}>Next: {guideParts[partIndex + 1].week} →</button>
                ) : (
                  <Link to="/aws-clf-c02-practice" className="btn btn-orange">Start practising →</Link>
                )}
              </div>
            </>
          )}
        </div>
      </div>
    </Layout>
  );
};

export default AWSCLFC02GuidePage;
